import { ProcessFlow } from './../enums/processFlow.enum';
import { ProcessType } from './../enums/processType.enum';
import { MessageState } from '../enums/messageStates.enum';

export class TaskBasicInfo {
    public id!: string;
    public customerId!: string;
    public customerName!: string;
    public customerReference!: string;
    public customerIsDeleted!: boolean;
    public state!: MessageState;
    public requestedProcess!: ProcessType;
    public processFlow!: ProcessFlow;
    public createStamp!: Date;
    public pluginHistory!: string[];
    public status!: string;
}
